export enum RECORD_UPDATE_TYPES {
  RECORD_UPDATE = 'Record Update',
  MISSING_INFORMATION = 'Missing Information',
  INCORRECT_INFORMATION = 'Incorrect Information',
}

export const RECORD_UPLOAD = 'record-upload';
